import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Fonts Import
import "@fontsource/bricolage-grotesque"; // Defaults to weight 400.
import "@fontsource/bricolage-grotesque/400.css"; // Optionally specify weight.
import "@fontsource/bricolage-grotesque/600.css"; // Specify additional weights if needed.
import "@fontsource/bricolage-grotesque/700.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
